module.exports = __webpack_public_path__ + "img/17-7.acc27957.jpg";